var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38409 12.9073L8.80053 14.3237L13.8234 9.30086L8.80053 4.27803L7.38409 5.69447L9.97587 8.2963H0.261719V10.3054H9.97587L7.38409 12.9073ZM16.3348 0.259766H2.27085C1.15578 0.259766 0.261719 1.16388 0.261719 2.2689V6.28716H2.27085V2.2689H16.3348V16.3328H2.27085V12.3146H0.261719V16.3328C0.261719 17.4378 1.15578 18.342 2.27085 18.342H16.3348C17.4398 18.342 18.3439 17.4378 18.3439 16.3328V2.2689C18.3439 1.16388 17.4398 0.259766 16.3348 0.259766Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLogout);
export default __webpack_public_path__ + "static/media/ico-logout.84ff8ad0681162375004d98e155fb0bc.svg";
export { ForwardRef as ReactComponent };